import { render, staticRenderFns } from "./AdmisionHabilitadosAptitud.vue?vue&type=template&id=0242f643"
import script from "./AdmisionHabilitadosAptitud.vue?vue&type=script&lang=js"
export * from "./AdmisionHabilitadosAptitud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports